import { createSlice, createSelector } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'



const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}



const sectionSlice = createSlice({
    name: 'sections',
    initialState,
    reducers: {
        sectionAdd(state, action) {
            const sectionData = action.payload
            state.entities[sectionData.SectionId] = sectionData
        },
        sectionModify(state, action) {
            const sectionData = action.payload
            state.entities[sectionData.SectionId] = sectionData
        },
        sectionDelete(state, action) {
            const sectionData = action.payload
            delete state.entities[sectionData.SectionId]
        },
        sectionHydrate(state, action) {
            const sectionData = action.payload
            state.entities=sectionData
            state.status = 'success'
        },
        sectionClear(state,action) {
            state.status = 'idle'
        }
    }
})

export const { sectionAdd, sectionModify, sectionDelete, sectionHydrate } = sectionSlice.actions

export default sectionSlice.reducer

const selectSectionEntities = (state) => state.sections.entities

export const selectSections = createSelector(selectSectionEntities, (entities) =>
    Object.values(entities)
)

export const selectSectionById = (state, SectionId) => {
    return selectSectionEntities(state)[SectionId]
}

export const selectSectionsInCurrentSurvey = createSelector(
    selectSections
    , (state, SurveyId) => SurveyId
    , (sections, SurveyId) => {

        return sections.filter((section) => {
            return section.SurveyId === SurveyId
        })
    }

)